<template>
	<main-layout class="linksMainDiv">
			<div v-show="!loaded" class="top160" id="slinkHeader"></div>
			<div v-if="loaded" class="container has-text-white">
			<img src="/static/logQC.png" width="150" class="is-pulled-right top40 handCursor" @click="navTo('', true)" />
			<br>
			<div class="top40 is-size-1 top80 has-text-dark" >
				<img src="@/assets/img/chevronsY.png" class="right5"  width="30" /><span class="has-text-yell"><b>{{slink}}<span class="has-text-turk">:links</span></b></span>
				<div class="is-size-5 top5 left30 has-text-light">slink.com/{{slink}}:links</div>
			</div>

		<div class="pageDescriptionContainer">
				<div  v-show="pageDescription"  class="pageDescription container">
					{{pageDescription}}
				</div>
		</div>
			
			
			<div class="left20 top30 is-size-4" >
				<!-- <div class="has-text-right"> <button class="button is-dark" :class="{'is-yell': sortAlpha}" @click="toggleSort"><i class="fas fa-sort-alpha-down"></i></button></div> -->
				
				<div v-if="!noShow" class="top15 lpSub main" @click="navTo(slink, true)">
					<div class="columns lpCols">
						<div class="column lpTitle is-one-third">
							<div class="top10 isPoppins is-size-2"><img src="@/assets/img/chevronsW.png" class="right3"  width="25" /><b>{{slink}}</b></div>
						</div>
						<div class="column is-size-5">
							<div class="lpDescHomeMain">{{description}}</div>
						</div>
					</div>
					<div class="is-size-6 left15 top5">slink.com/<b>{{slink}}</b></div>
				</div>

				<div v-show="noShow" class="">
					<div class="left10 has-text-white">Sorry but there are no public subslinks being shared for this slink.</div>
				</div>
				
				
				<div class=" top20">

				


					<div class="left20 top15 lpSub" v-for="(item, i) in links" :key="i" @click="navTo(item.url)">
						<div class="columns lpCols">
							<div class="isPoppins lpTitle is-size-4 column is-one-third">
								<b>:{{item.name}}</b>
							</div>
							<div class="column is-size-5">
								<div class="lpDescHome">{{item.description}}</div>
							</div>
						</div>
						<div class="is-size-6 left10">slink.com/{{slink}}<b>:{{item.name}}</b></div>
					</div>
				</div>
				
			</div>
			
			<div class="has-text-centered has-text-light alignBottom top80 bottom20">
				<div class="is-size-7">Copyright &copy;2022 Slink, Inc.</div>
			</div>
		</div>
</main-layout>
</template>

<script>

import MainLayout from '../layouts/Main.vue'
import { AZEventBus } from '../components/AZEventBus'

export default {
	components: {
		MainLayout
	},

	data: function(){
		return {
			inited: false,
			slink: '',
			links: [],
			links2: [],
			noShow: true,
			loaded: false,
			description: '',
			pageDescription: '',
			sortAlpha: false
		}
	},

	mounted: function(){

		document.getElementById('navBG').classList.add('hideMe')
		document.getElementById('azFooter').classList.add('hideMe')
		document.getElementById('azSize').style['margin-top'] = 0
		document.getElementById('azSize').style['min-height'] = '100vh'

		this.slink = this.$route.params.slink

		if(this.slink == undefined){
			this.$router.push('/')
		}   else {
			az.addRemSpinner(true, 'id', 'slinkHeader');  
		}
		var self = this;

		function w(d) {

			az.addRemSpinner(false, 'id', 'slinkHeader');
			self.noShow = false
			self.loaded = true
			self.links = d.links
			self.links2 = d.links
			self.description = d.description
			self.pageDescription = d.pageDescription
		
		}
		function n(obj) {
			az.addRemSpinner(false, 'id', 'slinkHeader');

			if(obj.message == 'Not Found' || obj.message == 'Forbidden'){
				self.loaded = true
				self.noShow = true
				return
			}

	
			self.$root.showModalOK({message: 'There was en arror loading contents.'})
		}


		function init(){
			if(self.slink != undefined){
				self.inited = true
				
				self.$root.apiClient.get(`api/links/${encodeURIComponent(self.slink)}`, {}, w, n)
			}
			
		}

		if(self.$root.doneFederating){
			init();
		}

		AZEventBus.$once('onFederate', msg => {
			if(self.inited == false)
				init();
			});

	},

	methods: {
		navTo: function(url, doProcess){
			if(doProcess){
				window.location.href = `https://${process.env.HOST}/${url}`
			} else {
				window.location.href = url
			}
		},

		toggleSort: function(){
        this.sortAlpha = !this.sortAlpha
        if(this.sortAlpha){
            this.links.sort((a,b) => {
                return b.date - a.date
            })
            
        } else {
           this.links = this.links2
        }
    }
	}

}

</script>


// WEBPACK FOOTER //
// src/pages/Links.vue